module.exports = __webpack_public_path__ + "automation.png?1ca10f8eeff679b1d7f42f5540628416";